const map = {
	"./Uptech-marker-alerts-icon-high-DoB.png": 5878,
	"./Uptech-marker-alerts-icon-high-animal.png": 8529,
	"./Uptech-marker-alerts-icon-high-boat.png": 6059,
	"./Uptech-marker-alerts-icon-high-deformation.png": 927,
	"./Uptech-marker-alerts-icon-high-electric-tower.png": 316,
	"./Uptech-marker-alerts-icon-high-intrusion.png": 5342,
	"./Uptech-marker-alerts-icon-high-landslide.png": 7695,
	"./Uptech-marker-alerts-icon-high-leaks.png": 1381,
	"./Uptech-marker-alerts-icon-high-machinery.png": 6969,
	"./Uptech-marker-alerts-icon-high-manhole.png": 9111,
	"./Uptech-marker-alerts-icon-high-rock-falling.png": 7656,
	"./Uptech-marker-alerts-icon-high-submarine_impact.png": 6776,
	"./Uptech-marker-alerts-icon-high-temperature.png": 8451,
	"./Uptech-marker-alerts-icon-high-vehicle.png": 5145,
	"./Uptech-marker-alerts-icon-intermediate-DoB.png": 2449,
	"./Uptech-marker-alerts-icon-intermediate-animal.png": 5632,
	"./Uptech-marker-alerts-icon-intermediate-boat.png": 854,
	"./Uptech-marker-alerts-icon-intermediate-deformation.png": 6596,
	"./Uptech-marker-alerts-icon-intermediate-electric-tower.png": 525,
	"./Uptech-marker-alerts-icon-intermediate-intrusion.png": 3029,
	"./Uptech-marker-alerts-icon-intermediate-landslide.png": 1028,
	"./Uptech-marker-alerts-icon-intermediate-leaks.png": 3458,
	"./Uptech-marker-alerts-icon-intermediate-machinery.png": 1602,
	"./Uptech-marker-alerts-icon-intermediate-manhole.png": 5564,
	"./Uptech-marker-alerts-icon-intermediate-rock-falling.png": 3949,
	"./Uptech-marker-alerts-icon-intermediate-submarine_impact.png": 9545,
	"./Uptech-marker-alerts-icon-intermediate-temperature.png": 4056,
	"./Uptech-marker-alerts-icon-intermediate-vehicle.png": 8858,
	"./Uptech-marker-alerts-icon-low-DoB.png": 9426,
	"./Uptech-marker-alerts-icon-low-animal.png": 4493,
	"./Uptech-marker-alerts-icon-low-boat.png": 4639,
	"./Uptech-marker-alerts-icon-low-deformation.png": 4939,
	"./Uptech-marker-alerts-icon-low-electric-tower.png": 6056,
	"./Uptech-marker-alerts-icon-low-intrusion.png": 7922,
	"./Uptech-marker-alerts-icon-low-landslide.png": 1835,
	"./Uptech-marker-alerts-icon-low-leaks.png": 3649,
	"./Uptech-marker-alerts-icon-low-machinery.png": 2269,
	"./Uptech-marker-alerts-icon-low-manhole.png": 635,
	"./Uptech-marker-alerts-icon-low-rock-falling.png": 6116,
	"./Uptech-marker-alerts-icon-low-submarine_impact.png": 804,
	"./Uptech-marker-alerts-icon-low-temperature.png": 9287,
	"./Uptech-marker-alerts-icon-low-vehicle.png": 2869
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1702;